import axios from 'axios';
import { FETCH_CURRENCY, FETCH_CURRENCY_FAIL, FETCH_DEVELOPMENT_CURRENCY } from './types';
import { DEVELOPMENT_CURRENCY } from '../config';

/**
 * Fetch currency via Busabout API
 */
export function FetchCurrency() {

    const CURRENCY_URL = process.env.REACT_APP_TMS_CURRENCY_API;

    return async dispatch => {
      try{

        if(process.env.NODE_ENV === 'production'){
          const data = await axios.get(CURRENCY_URL);
          dispatch({type:FETCH_CURRENCY, payload:data});
          return data;
        }else{
          dispatch({type:FETCH_DEVELOPMENT_CURRENCY});
          return DEVELOPMENT_CURRENCY;
        }

      }
      catch(err){
        dispatch({type:FETCH_CURRENCY_FAIL});
        console.error(err);
      };
  }
}